import { Link } from "react-router-dom";
import type { AnimeArticle } from "@/mocks/animeData";

interface RankingItemProps {
  article: AnimeArticle;
  rank: number;
  type: "season" | "total";
}

export default function RankingItem({ article, rank, type }: RankingItemProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors duration-200 group cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
    >
      <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold text-sm font-heading">
        {rank}
      </div>
      <div className="flex-shrink-0 w-14 h-14 rounded-md overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 font-heading">
          {article.title}
        </h4>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{article.category}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">
            {type === "season" ? `第${article.seasonRank}名` : `第${article.totalRank}名`}
          </span>
        </div>
      </div>
      <div className="flex-shrink-0 flex items-center gap-1">
        <span className="text-lg font-bold text-primary-500 font-heading">{article.rating}</span>
      </div>
    </Link>
  );
}